// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"subscribe-module--subscribe--1nMDD","header":"subscribe-module--header--96n2G","description":"subscribe-module--description--2rrrf"};